import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full overflow-x-auto border border-[#d8d8e2] rounded-lg" }
const _hoisted_2 = { class: "w-full min-w-[900px] border-collapse" }
const _hoisted_3 = { class: "bg-[#f0f0f4]" }
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = { class: "px-4 py-3" }
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = { class: "flex flex-col gap-0.5 overflow-hidden" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "text-[13px] font-semibold text-[#16161d] truncate" }
const _hoisted_10 = { class: "text-[11px] text-[#52526f] text-left" }
const _hoisted_11 = { class: "px-4 py-3" }
const _hoisted_12 = {
  key: 1,
  class: "text-[13px] text-[#16161d]"
}
const _hoisted_13 = { class: "px-4 py-3" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col items-center gap-0.5"
}
const _hoisted_15 = { class: "text-[13px] text-[#16161d]" }
const _hoisted_16 = { class: "text-[12px] font-bold text-[#16161d]" }
const _hoisted_17 = {
  key: 1,
  class: "text-[13px] text-[#16161d]"
}
const _hoisted_18 = { class: "px-4 py-3 text-center" }
const _hoisted_19 = { class: "flex justify-center" }
const _hoisted_20 = { class: "px-4 py-3 text-center flex items-center justify-center" }

import StatusBadge from '@/components/designSystem/Badges/StatusBadge.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { FacialBiometryStatus } from '@/constants/facial-biometry.constants'
import type { FacialBiometryDoctorItem } from '@/types/facial-biometry.types'
import { formatCrm } from '@/utils/formatters'
import { formatDoctorShortName } from '@/utils/string'
import { formatDateInOffset, formatHourMinuteWithZoneInOffset } from '@/utils/date'
import NpsScoreAvatar from '@/components/designSystem/AvatarUser/NpsScoreAvatar.vue'
import InitialsFallback from './InitialsFallback.vue'
import ScheduleSummary from './ScheduleSummary.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FacialBiometryTable',
  props: {
    doctors: {}
  },
  emits: ["evaluate", "viewHistory", "notify"],
  setup(__props: any, { emit }) {





const columns = [
  { key: 'doctor', label: 'Médico' },
  { key: 'schedule', label: 'Escala' },
  { key: 'date', label: 'Data de envio' },
  { key: 'status', label: 'Status' },
  { key: 'actions', label: 'Ações' }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
            return _createElementVNode("th", {
              key: col.key,
              class: "px-4 py-2.5 text-sm font-bold text-[#272735] text-center"
            }, _toDisplayString(col.label), 1)
          }), 64))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctors, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.doctor.id + '-' + (item.id ?? 'no-bio'),
            class: "border-t border-[#e8e8ed] bg-white hover:bg-[#fafafa] transition-colors",
            "data-testid": `biometry-row-${item.doctor.id}`
          }, [
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(NpsScoreAvatar, {
                  "nps-score": item.doctor.npsScore,
                  "avatar-url": item.doctor.photoUrl,
                  "stroke-width": 4,
                  role: "img",
                  "aria-label": item.doctor.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(InitialsFallback, {
                      name: item.doctor.name
                    }, null, 8, ["name"])
                  ]),
                  _: 2
                }, 1032, ["nps-score", "avatar-url", "aria-label"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(formatDoctorShortName)(item.doctor.name)), 1)
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatCrm)(item.doctor.crm, item.doctor.crmUf)), 1)
                ])
              ])
            ]),
            _createElementVNode("td", _hoisted_11, [
              (item.schedules.length)
                ? (_openBlock(), _createBlock(ScheduleSummary, {
                    key: 0,
                    schedules: item.schedules,
                    align: "center",
                    dense: ""
                  }, null, 8, ["schedules"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
            ]),
            _createElementVNode("td", _hoisted_13, [
              (item.createdAt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(formatDateInOffset)(item.createdAt)), 1),
                    _createElementVNode("span", _hoisted_16, " às " + _toDisplayString(_unref(formatHourMinuteWithZoneInOffset)(item.createdAt)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
            ]),
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(StatusBadge, {
                  status: item.status
                }, null, 8, ["status"])
              ])
            ]),
            _createElementVNode("td", _hoisted_20, [
              (item.status === _unref(FacialBiometryStatus).NOT_SUBMITTED)
                ? (_openBlock(), _createBlock(OutlineButton, {
                    key: 0,
                    "data-testid": `notify-button-${item.doctor.id}`,
                    text: "Notificar",
                    width: "auto",
                    height: "revert-layer",
                    onClick: ($event: any) => (emit('notify', item))
                  }, null, 8, ["data-testid", "onClick"]))
                : (item.status === _unref(FacialBiometryStatus).PENDING)
                  ? (_openBlock(), _createBlock(OutlineButton, {
                      key: 1,
                      "data-testid": `evaluate-button-${item.doctor.id}`,
                      text: "Avaliar",
                      width: "auto",
                      height: "revert-layer",
                      onClick: ($event: any) => (emit('evaluate', item))
                    }, null, 8, ["data-testid", "onClick"]))
                  : (_openBlock(), _createBlock(GhostButton, {
                      key: 2,
                      "data-testid": `history-button-${item.doctor.id}`,
                      text: "Ver Histórico",
                      width: "auto",
                      height: "revert-layer",
                      onClick: ($event: any) => (emit('viewHistory', item))
                    }, null, 8, ["data-testid", "onClick"]))
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})